export const CategoryImagePath = {
  korean: `${process.env.PUBLIC_URL}/images/category-korean.png`,
  chinese: `${process.env.PUBLIC_URL}/images/category-chinese.png`,
  japanese: `${process.env.PUBLIC_URL}/images/category-japanese.png`,
  asian: `${process.env.PUBLIC_URL}/images/category-asian.png`,
  western: `${process.env.PUBLIC_URL}/images/category-western.png`,
  etc: `${process.env.PUBLIC_URL}/images/category-etc.png`,
};
